import React from 'react';
import ElectricDeviceDetectionTooltip from '@di-shared/features/diag/battery/discharge/ElectricDeviceDetectionTooltip';
import PowerConsumptionTooltip from '@di-shared/features/diag/battery/discharge/PowerConsumptionTooltip';
import useBatteryStatus, {ExternalDevicePowerConsumptionRating} from '@di-shared/features/diag/battery/useBatteryStatus';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import clsx from 'clsx';
import ElectronicDeviceDetectionGraph from '@di-shared/features/diag/battery/discharge/ElectronicDeviceDetectionGraph';

interface ElectronicDeviceDetectionProps {
  vin: string;
}

function ElectronicDeviceDetection({vin}: ElectronicDeviceDetectionProps) {
  const {t} = useInferableTranslation();
  const {powerConsumptionRating} = useBatteryStatus(vin);
  return (
    <div className="section_container">
      <div className="section_container_header">
        <h3 className="title_xxsmall">{t('T30111')}</h3>
        <ElectricDeviceDetectionTooltip />
      </div>
      <div className="electronic_detect">
        <div className="electronic_detect_graph_area">
          <ElectronicDeviceDetectionGraph powerConsumptionRating={powerConsumptionRating} />
        </div>
        <div
          className={clsx('electronic_detect_info', {
            type_good: powerConsumptionRating === ExternalDevicePowerConsumptionRating.LOW,
            type_caution: powerConsumptionRating === ExternalDevicePowerConsumptionRating.NORMAL,
            type_warning: powerConsumptionRating === ExternalDevicePowerConsumptionRating.HIGH,
            type_danger: powerConsumptionRating === ExternalDevicePowerConsumptionRating.VERY_HIGH,
          })}
        >
          <div className="tooltip_center_wrap">
            <span className="electronic_detect_title">{t('T30148')}</span>
            <PowerConsumptionTooltip />
          </div>
          {powerConsumptionRating === ExternalDevicePowerConsumptionRating.LOW && (
            <strong className="electronic_detect_state">{t('T30112')}</strong>
          )}
          {powerConsumptionRating === ExternalDevicePowerConsumptionRating.NORMAL && (
            <strong className="electronic_detect_state">{t('T30114')}</strong>
          )}
          {powerConsumptionRating === ExternalDevicePowerConsumptionRating.HIGH && (
            <strong className="electronic_detect_state">{t('T30115')}</strong>
          )}
          {powerConsumptionRating === ExternalDevicePowerConsumptionRating.VERY_HIGH && (
            <strong className="electronic_detect_state">{t('T30116')}</strong>
          )}
        </div>
      </div>
      <div className="divider"></div>
      {powerConsumptionRating === ExternalDevicePowerConsumptionRating.LOW && (
        <ul className="section_bullet_list body_medium_r">
          <li className="section_bullet_item">{t('T30120')}</li>
        </ul>
      )}
      {powerConsumptionRating === ExternalDevicePowerConsumptionRating.NORMAL && (
        <ul className="section_bullet_list body_medium_r">
          <li className="section_bullet_item">{t('T30120')}</li>
        </ul>
      )}
      {powerConsumptionRating === ExternalDevicePowerConsumptionRating.HIGH && (
        <ul className="section_bullet_list body_medium_r">
          <li className="section_bullet_item">{t('T30119')}</li>
          <li className="section_bullet_item">{t('T30121')}</li>
          <li className="section_bullet_item">{t('T30122')}</li>
        </ul>
      )}
      {powerConsumptionRating === ExternalDevicePowerConsumptionRating.VERY_HIGH && (
        <ul className="section_bullet_list body_medium_r">
          <li className="section_bullet_item">{t('T30123')}</li>
          <li className="section_bullet_item">{t('T30121')}</li>
          <li className="section_bullet_item">{t('T30124')}</li>
          <li className="section_bullet_item">{t('T30122')}</li>
        </ul>
      )}
    </div>
  );
}

export default ElectronicDeviceDetection;
